import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.PHARMACY_GROUP_LIST_REQUEST:
      return {
        ...state,
        data: [],
        isProgress: true,
      };
    case homeConstants.PHARMACY_GROUP_LIST_SUCCESS:
      return {
        ...state,
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.PHARMACY_GROUP_LIST_FAILURE:
      return {
        ...state,
        data: [],
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
}
